/* eslint-disable import/no-extraneous-dependencies */
import {
 call, put, delay, select,
} from 'redux-saga/effects';
import Auth from '@aws-amplify/auth';

const isPublic = ({ isPublic }) => isPublic;

export function* getAuthHeaders() {
  const toolIsPublic = yield select(isPublic);

  if (toolIsPublic) return;

  const previousExpireTime = yield select(
    ({ credExpiration }) => credExpiration,
  );

  const currentUser = yield call([Auth, Auth.currentUserInfo]);

  if (!currentUser || new Date(previousExpireTime) >= new Date()) {
    // check for token expiration every second
    yield delay(5000);
    yield call(getAuthHeaders);
    return;
  }
  const currentCredentials = yield call([Auth, Auth.currentUserCredentials]);
  const essentialCredentials = yield call(
    [Auth, Auth.essentialCredentials],
    currentCredentials,
  );

  const { secretAccessKey, accessKeyId, sessionToken } = essentialCredentials;
  const { expiration } = currentCredentials;

  const creds = {
    secret_key: secretAccessKey,
    access_key: accessKeyId,
    session_token: sessionToken,
  };

  yield put({
    type: 'SET_CREDENTIALS',
    payload: {
      credentials: creds,
      expiration,
    },
  });
  yield call(getAuthHeaders);
}
